import i18n from '@/i18n'
import { changeUrlQuery, getParams } from '@kso/util'
import DialogDownload from '@kso/ui/lib/DialogDownload'
import { isSpecialFrame, ua } from '@/utils/tools'
import sdk from '@/sdk/index'
import { GetFileInfoByFileId } from '@/services/api'
import { isMacWPS } from '@/utils/utm'
import { callWPSClientAPI } from '@/sdk/wpsoffice'
interface IFileInfo {
  groupid: string | number;
  fileid: string | number;
  fsize?: number;
  fname?: string;
}
export default class DownloadCommand {
  downloadUrl: string
  fileInfo: IFileInfo
  isErrorPage: boolean
  constructor(downloadUrl, fileInfo: IFileInfo, isErrorPage = false) {
    this.downloadUrl = downloadUrl
    this.fileInfo = fileInfo
    this.isErrorPage = isErrorPage
  }

  async execute() {
    const { wxpcmini, mWOA, mdocs, wxminiprogram, qqminiprogram } = ua
    try {
      const { fname, fileid } = this.fileInfo
      if (!fname) {
        const { fileinfo = {} } = await GetFileInfoByFileId(fileid)
        this.fileInfo = Object.assign({}, this.fileInfo, {
          fname: fileinfo.fname,
          fsize: fileinfo.fsize
        })
      }
      // 移动端、woa
      if (mWOA || mdocs) {
        await sdk.call('file.download.start', {
          url: this.downloadUrl,
          fname: this.fileInfo.fname,
          fsize: this.fileInfo.fsize || 0
        })
        return
      }
      // 小程序-PC端、pad下载逻辑补充
      if (wxpcmini) {
        const url = this.downloadUrl
        try {
          if (url) {
            DialogDownload.show({ url })
            return
          }
        } catch (e) {
          console.error('Download failed')
        }
        // 小程序移动端下载逻辑补充
      } else if (wxminiprogram || qqminiprogram) {
        return await this.downloadWithWxMini()
      }
      if (isMacWPS && this.isErrorPage) {
        try {
          return await callWPSClientAPI(
            'common.util.selectPath',
            {
              params: {
                api: 'fromJSAsynCall'
              }
            },
            async (dir) => {
              if (typeof dir === 'string') {
                dir = JSON.parse(dir.replaceAll('\\', '\\\\'))
              }
              if (!dir?.result?.path) {
                return
              }
              let fileName = this.fileInfo.fname
              try {
                // 这里获取到是最准确的下载文件名
                fileName = decodeURIComponent(
                  getParams(decodeURIComponent(this.downloadUrl))[
                    'response-content-disposition'
                  ].split('\'\'')[1]
                )
              } catch {
                throw new Error(i18n.t('4e0e975d62'))
              }
              if (!fileName) {
                throw new Error(i18n.t('04edf8028f'))
              }
              await callWPSClientAPI('common.util.download', {
                params: {
                  url: this.downloadUrl,
                  // @ts-ignore
                  path: `${dir.result.path}${window?.__UA__?.isWindows ? '\\' : '/'}${fileName}`,
                  directGet: true
                }
              })
            }
          )
        } catch (e) {
          window.open(this.downloadUrl)
        }
      }
      this.redirectUrl()
    } catch (e) {
      this.redirectUrl()
    }
  }
  redirectUrl() {
    const url = isSpecialFrame
      ? `https://www.kdocs.cn/download/tips?q=${encodeURIComponent(this.downloadUrl)}`
      : this.downloadUrl
    // 微信内嵌、QQ、钉钉等访问音视频时，下载跳转的地址被封了，故添加个中转页处理
    window.location.href = url
  }

  // 小程序下载文档：https://www.kdocs.cn/l/ckwzQS5hORcZ?openfrom=docs
  async downloadWithWxMini() {
    const { wxminiprogram, qqminiprogram } = ua
    const { fname, fsize, groupid, fileid } = this.fileInfo || {}
    if (!window.wx?.miniProgram) {
      return this.redirectUrl()
    }
    const fileInfo = {
      groupid,
      fid: fileid,
      fname: fname,
      fsize: ~~(Number(fsize) / 1024) || 0
    }
    const downloadPage = '/pages/downloadFiles/downloadFiles'
    const extraParams: {
      downloadPage: number;
      downloadUrl?: string;
    } = {
      downloadPage: wxminiprogram ? 0 : 1
    }
    // qq小程序需要传 downloadUrl
    if (qqminiprogram) {
      extraParams.downloadUrl = this.downloadUrl
    }
    const url = changeUrlQuery(
      downloadPage,
      Object.assign({}, fileInfo, extraParams)
    )
    window.wx.miniProgram.navigateTo?.({
      url,
      fail: () => {
        this.redirectUrl()
      }
    })
  }
}
